<template>
  <div>
    <div class="title">
      <div>当前可用总余额：<span class="colorRed">￥{{ sumBalance }}</span></div>
      <div>
        <el-button type="text" @click="handleNewCard">绑定新券</el-button>
      </div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="可用券" name="card0">
        <span slot="label">可用券</span>
        <myCard ref="childRef0" :status="1" />
      </el-tab-pane>
      <el-tab-pane label="不可用券" name="card1">
        <span slot="label">不可用券</span>
        <myCard ref="childRef1" :status="0" />
      </el-tab-pane>
    </el-tabs>
    <newCard ref="newCard" @refreshList="handleNewClick" />
  </div>
</template>
<script>
import myCard from './myCard.vue'
import newCard from './newCard.vue'
import { cdkeyMyBalance } from '@/api/gift.js'
export default {
  name: 'MyGiftCard',
  components: {
    myCard,
    newCard
  },
  data() {
    return {
      activeName: 'card0',
      sumBalance: null
    }
  },
  created() {},
  mounted() {
    this.getCdkeyMyBalance()
  },
  methods: {
    handleClick(tab) {
      this.$refs['childRef' + [tab.index]].getGiftCardList()
    },
    handleNewCard() {
      this.$refs['newCard'].show()
    },
    //
    handleNewClick() {
      this.$refs['childRef0'].getGiftCardList()
      this.getCdkeyMyBalance()
    },
    // 获取总余额
    getCdkeyMyBalance() {
      cdkeyMyBalance().then(res => {
        this.sumBalance = res.data.sumBalance
      })
    }
  }
}
</script>
<style scoped>
.title{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.colorRed{
  color: red
}
</style>
